import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { useSelect, useDispatch } from '@wordpress/data';
import apiFetch from '@wordpress/api-fetch';
import {
    CHECKOUT_STORE_KEY,
    VALIDATION_STORE_KEY,
    CART_STORE_KEY,
} from '@woocommerce/block-data';
import { useEffect, useState } from '@wordpress/element';
import { PAYMENT_METHOD_NAME } from '../contants';

const PayPalPayment = ( { onSubmit, config, eventRegistration, ...props } ) => {
    const orderId = useSelect( ( select ) =>
        select( CHECKOUT_STORE_KEY ).getOrderId(),
        []
    );

    const { gatewayOptions } = config;
    const { activePaymentMethod, emitResponse } = props;
    const { responseTypes } = emitResponse;
    const [ paypalOrder, setPaypalOrder ] = useState( null );
    const [ isPaymentProcessing, setIsPaymentProcessing ] = useState( false );
    const { onPaymentSetup } = eventRegistration;

    const { showAllValidationErrors } = useDispatch( VALIDATION_STORE_KEY );

    const { hasValidationErrors, isCustomerDataUpdating } = useSelect(
        ( select ) => {
            return {
                hasValidationErrors:
                    select( VALIDATION_STORE_KEY ).hasValidationErrors,
                isCustomerDataUpdating:
                    select( CART_STORE_KEY ).isCustomerDataUpdating(),
            };
        }, []
    );

    const validateCheckoutForm = () => {
        showAllValidationErrors();
        return ! hasValidationErrors();
    };

    useEffect( () => {
        if ( activePaymentMethod !== PAYMENT_METHOD_NAME ) {
            return;
        }
        validateCheckoutForm();
        const unsubscribeProcessing = onPaymentSetup( () => {
            return {
                type: responseTypes.SUCCESS,
                meta: {
                    paymentMethodData: {
                        dokan_paypal_order_id: paypalOrder?.id,
                    },
                },
            };
        } );

        return () => {
            unsubscribeProcessing();
        };
    }, [ paypalOrder, activePaymentMethod, onPaymentSetup ] );

    const createPayment = async ( props ) => {
        try {
            setIsPaymentProcessing( true );
            const response: any = await apiFetch( {
                path: '/dokan/v1/paypal-marketplace/create-payment/' + orderId,
                method: 'POST',
            } );

            return response.paypal_order_id;
        } catch ( error ) {
            setIsPaymentProcessing( false );
            console.error( 'Error creating PayPal order:', error );
        }
    };

    const capturePayment = async ( data, actions ) => {
        try {
            const order = await actions.order.get();

            await apiFetch( {
                path: '/dokan/v1/paypal-marketplace/capture-payment/' + orderId,
                method: 'POST',
            } );

            setPaypalOrder( order );
            onSubmit();
        } catch ( error ) {
            setIsPaymentProcessing( false );
            console.error( 'Error creating PayPal order:', error );
        }
    };

    return (
        <PayPalScriptProvider options={ gatewayOptions }>
            <PayPalButtons
                createOrder={ createPayment }
                onApprove={ capturePayment }
                disabled={
                    isCustomerDataUpdating ||
                    hasValidationErrors() ||
                    isPaymentProcessing
                }
                onError={ ( err ) => {
                    console.error( 'Paypal Error-->', err );
                } }
            />
        </PayPalScriptProvider>
    );
};

export default PayPalPayment;
